import { store } from 'react-notifications-component';
export const MONTHS_STRINGS = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Aout',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

export const WEEKDAYS_LONG = [
  'Dimanche',
  'Lundi',
  'Mardi',
  'Mercredi',
  'Jeudi',
  'Vendredi',
  'Samedi',
];

export const WEEKDAYS_SHORT = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];

export const arrayToObject = (arr, key = 'appId') => {
  const obj = {};
  arr.forEach(element => {
    obj[element[key]] = element;
  });
  return obj;
};
export function mapFiltersFromTableData(arrays, keys) {
  let result = {}
  for (let i = 0; i < keys.length; i++) {
    const values = arrays.map(item => item[keys[i]]).filter(item => !!item)
    result[keys[i]] = values.filter(function (item, pos) {
      return values.indexOf(item) == pos;
    })
  }
  return result
}
export function includesSearchWord(title, searchWord) {
  if (searchWord === '') {
    return true;
  }
  return (
    String(title).toLowerCase().indexOf(String(searchWord).toLowerCase()) >= 0
  );
}

export function removeDuplicateFromArray(a, key) {
  return a.filter((value, index, self) =>
    index === self.findIndex((t) => (
      key ? t[key] == value[key] : t == value
    ))
  )
}

export const appendArrayDataToFormData = (formData, data, field) => {
  for (const item of data) {
    formData.append(`${field}[]`, item);
  }
}
export const makeid = (length) => {
  let result = '';
  let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i++) {
    result += getSecureRandomChar(characters);
  }
  return result;
}
function getSecureRandomChar(characters) {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  const randomIndex = array[0] % characters.length;
  return characters.charAt(randomIndex);
}

export const getValueFromEventType = (event) => {
  if (event.target.type === 'checkbox') return event.target.checked
  return event.target.name === 'email'
    ? String(event.target.value).trim()
    : event.target.value
}

export const getInputType = (key) => {
  if (key === 'email') return 'email'
  return ['password', 'passwordConfirm'].indexOf(key) >=
    0 ? (
    'password'
  ) : (
    'text'
  )
}

export const showMessage = (payload) => {
  store.addNotification({
    message: "",
    type: 'success',
    container: 'top-right',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: 5000,
      onScreen: true,
    },
    ...payload,
  });
}